/**
 * itemsPerPage will be dynamically calculated using JS. However, in our
 * standalone nextJS version, content will be displayed before JS has been
 * fully loaded.
 *
 * As such we create a bunch of statically determined breakpoints that sets the
 * itemsPerPage to the value which it should be at that width. This ensures
 * that minimal jumping occurs when JS is loaded and the dynamic itemsPerPage
 * is applied.
 */

const wrapper = "_uqxw19a4g7k";
const content = "_uqxc19ogtr3";
const sliderWrapper = "_uqxs1xw0pls";
const card = "_uqxc1mje8ft";
const prevButton = "_uqxp1217r1u";
const nextButton = "_uqxn19rlfvc";
const button = "_uqxbhvoajq";

export { button, card, content, nextButton, prevButton, sliderWrapper, wrapper };
import "./card-slider.style.linaria.module.css";
//# sourceMappingURL=card-slider.style.js.map
